import React from 'react';
import PartnerForm from '../../../components/partner/partner-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as partnersActions from '../../../actions/partners';
import Loading from '../../../components/loading';
import AdminItemPageContainer from '../admin-item-page-container';
import LocalizedStrings from '../../../localization/strings';

class PartnerContainer extends AdminItemPageContainer {

    getBaseUrl() {
        return '/admin/partners';
    }

    fetchItem(id) {
        return this.props.actions.fetchPartner(id);
    }

    render() {
        const {actions, loading} = this.props;

        return (
            <div className="panel">
                <header className="panel-header">{LocalizedStrings.partnerEdit}</header>
                <div className="panel-body">
                    {loading
                        ? <Loading/>
                        : <PartnerForm submit={actions.submitPartner} onSuccessSubmit={this.onSuccessSubmit.bind(this)}></PartnerForm>
}
                </div>
            </div>
        )

    }
}

export default connect(function(state) {
    return {loading: state.admin.partners.loading};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...partnersActions
        }, dispatch)
    };
})(PartnerContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/partner/partner-container.js